module.exports = __webpack_public_path__ + "static/img/HumPOG.fc1a03e8.png";